export const licenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjUzMDVjZDVlLWIwYmItMTFlNC04YTAzLTU0NDI0OWY1MDViZCIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQyCn0=.f5EC8kAxy+zbxaWoWDjT7iGRTonJcaGIKeqm7V6dNc5sK/f5au9juy30LSSuDbQ4m/6PJJA0fWI3vJkZzBIInGOGuO57EMxqDAygq+3ClsROXt18iFlrUVi3LXDfn5IEGzhB3g==';
